module.exports = __webpack_public_path__ + "static/illustration404-7b03be8866e0b789a052692df479e9dd.svg";